import type { AdvancedMarkerProps } from '@vis.gl/react-google-maps';

import type ZorgbaseResult from '@/lib/models/zorgbase/ZorgbaseResult';

import { markerColorForOrganisation } from '@/lib/util';

export interface MapMarkerIconProps extends Omit<AdvancedMarkerProps, 'position'> {
	organisation: ZorgbaseResult;
	setInfowindowOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const MapMarkerIcon = ({ organisation, setInfowindowOpen }: MapMarkerIconProps) => {
	return (
		// biome-ignore lint/a11y/noStaticElementInteractions: map marker hover trigger; keyboard navigation on map markers is not meaningful
		// biome-ignore lint/a11y/useKeyWithMouseEvents: same as above
		<div
			onMouseOver={(e) => {
				e.preventDefault();
				setInfowindowOpen(true);
			}}
			onMouseOut={(e) => {
				e.preventDefault();
				setInfowindowOpen(false);
			}}
			style={{
				width: 18,
				height: 18,
				position: 'absolute',
				top: 0,
				left: 0,
				background: markerColorForOrganisation(organisation),
				border: `2px solid white`,
				borderRadius: '50%',
				transform: 'translate(-50%, -50%)',
			}}
		>
			{organisation.acceptsPatients && organisation.acceptsPassersBy ? (
				/* eslint-disable-next-line @next/next/no-img-element */
				<img src="/icons/both.svg" alt={`icon accepteert patienten en passanten`} style={{ margin: '-3px 0 0 -3px' }} />
			) : (
				''
			)}
		</div>
	);
};

// return (
// 	<div
// 		onMouseOver={(e) => { e.preventDefault(); setInfowindowOpen(true) }}
// 		onMouseOut={(e) => { e.preventDefault(); setInfowindowOpen(false) }}
// 		style={{
// 			width: iconProps.scale * 2,
// 			height: iconProps.scale * 2,
// 			position: 'absolute',
// 			top: 0,
// 			left: 0,
// 			background: iconProps.fillColor,
// 			border: `2px solid ${iconProps.strokeColor}`,
// 			borderRadius: '50%',
// 			transform: 'translate(-50%, -50%)'
// 		}}
// 	/>
// )

export default MapMarkerIcon;
